<template>
  <div class="chart-container">
    <v-chart
      :options="option"
      theme="light"
      autoresize
      @legendselectchanged="handleLegendSelectChange"
    />
  </div>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],

  props: ['items', 'type', 'selectedLabels'],

  computed: {
    filterItems () {
      return this.items.map((item) => {
        return {
          ...item,
          cashiers: item.cashiers.map((cashier) => {
            return {
              date: item.date,
              name: cashier.name,
              ...cashier,
            }
          }),
        }
      })
    },
    swapItems () {
      return this.filterItems.reduce((acc, cur) => {
        acc.push((this.filterItems[(this.filterItems.length - 1) - acc.length]))
        return acc
      }, [])
    },
    option () {
      // ['cashier a', 'cashier b', 'cashier c']
      const cashiersNames = this.swapItems.reduce((acc, cur) => {
        for (const cashier of cur.cashiers) {
          if (!acc.includes(cashier.name)) {
            acc.push(cashier.name)
          }
        }
        return acc
      }, [])
      const series = cashiersNames.map((value) => {
        return {
          name: value,
          type: this.type,
          stack: 'cashier',
          data: [
            ...this.swapItems.reduce((acc, cur) => {
              let number = 0
              for (const cashier of cur.cashiers) {
                if (cashier.date === cur.date && cashier.name === value) {
                  number = cashier.profit
                }
              }
              return acc.push(number) && acc
            }, []),
          ],
        }
      })
      const xAxisItems = this.swapItems.map((item) => item.date)

      return {
        animation: true,
        parallel: {
          width: '100%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: this.type === 'bar' ? 'shadow' : 'line',
          },
          formatter: (params) => {
            let html = ''
            html += `${params[0].axisValue}<br/>`
            for (const param of params) {
              html += `${param.marker} ${param.seriesName}: ${this.getNumber(param.value)}<br/>`
            }
            return html
          },
        },
        legend: {
          data: cashiersNames,
          selected: {
            ...(
              (() => {
                if (Object.keys(this.selectedLabels).length) {
                  return this.selectedLabels
                }
                const defaultActive = cashiersNames
                return cashiersNames.reduce((acc, cur) => {
                  acc[cur] = !!defaultActive.includes(cur)
                  return acc
                }, {})
              })()
            ),
          },
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter: (value, index) => {
              const currency = this.$store.getters.getCurrency
              const number = this.getNumber(value)
              return `${number} ${currency}`
            },
          },
        },
        xAxis: {
          type: 'category',
          data: xAxisItems,
        },
        series: series,
      }
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportCashierChart.vue